import { ProfileService } from '../profile.service';
import { ErrorList } from './../../../shared-components/controls/error-prompt/error-list.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ProfileAttachment } from '../profile-attachment.model';

@Component({
    selector: 'add-profile-attachment',
    templateUrl: './add-profile-attachment-dialog.component.html',
    styleUrls: [
        './add-profile-attachment-dialog.component.css'
    ]
})
export class AddProfileAttachmentDialogComponent implements OnInit {

    // Properties
    attachment: ProfileAttachment;
    errors: ErrorList[] = [];
    saved: boolean;
    @ViewChild('nameField', { read: ElementRef, static: true }) nameField: ElementRef;

    // Class Functions
    constructor(
        private dialogBox: MatDialogRef<AddProfileAttachmentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private profileService: ProfileService
    ) { }

    // Event Functions
    ngOnInit() {
        // POST: initializes the data
        if (this.data && this.data.attachment) {
            this.attachment = this.data.attachment;
        } else {
            this.attachment = new ProfileAttachment();
        }
    }

    save() {
        // PRE: the save button is clicked
        // POST: saves the attachment and closes the dialog box
        this.validate();
        if (this.errors.length == 0) {
            this.profileService.updateProfileAttachment(this.attachment).subscribe(id => {
                this.saved = true;
                this.attachment.FileID = id;
                this.dialogBox.close();
            });
        }
    }

    cancel() {
        // PRE: the cancel button is clicked
        // POST: closes the dialog box
        this.saved = false;
        this.dialogBox.close();
    }

    // Methods
    validate() {
        // POST: sets the errors
        this.errors = [];
        if (!this.attachment.MyFileName) {
            this.errors.push({
                fieldRef: this.nameField,
                fieldName: 'Name',
                errorMsg: 'Name is required.'
            });
        }
        if (!this.attachment.MyFile && !this.attachment.OriginalFileName) {
            this.errors.push({
                fieldRef: null,
                fieldName: 'File',
                errorMsg: 'File is required.'
            });
        }
    }
}